module.exports = __webpack_public_path__ + "static/img/321_TO8_2497_og.efd7281.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/321_TO8_2497_og.jpg
// module id = TnCI
// module chunks = 0